/* global Logger */
import {cloudinaryUploadAction} from './vanilla/cloudinary/cloudinary-upload'

const teacher = JSON.parse(document.getElementById('teacher').innerHTML)
const pictureUploadButton = document.getElementById('teacher-profile-upload')
if (pictureUploadButton) {
  pictureUploadButton.addEventListener('click', () => {
    cloudinaryUploadAction({
      context: {
        user_id: teacher.id,
        teacher_id: teacher.id,
      },
      cropping: 'server',
      croppingCoordinatesMode: 'face',
      croppingDefaultSelectionRatio: 0.5, // Defaults to 0.9, it's hard to click on the side to reset the selection
      tags: ['teacher_profile'],
      sources: ['local', 'camera', 'url', 'facebook', 'instagram'],
    }, (error, result) => {
      if (error) {
        Logger.debug('Failed to upload diploma: ' + error)
        return
      }
      if (result.event === 'success') {
        fetch('/teacher-profile-picture/' + teacher.id, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(result.info),
          credentials: 'include', // Sends cookies
        }).then(() => {
          location.reload()
        })
      }
    })
  })
}
